import { render, staticRenderFns } from "./relation_fine_group.vue?vue&type=template&id=2f8fd1c1&scoped=true&"
import script from "./relation_fine_group.vue?vue&type=script&lang=js&"
export * from "./relation_fine_group.vue?vue&type=script&lang=js&"
import style0 from "./relation_fine_group.vue?vue&type=style&index=0&id=2f8fd1c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8fd1c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f8fd1c1')) {
      api.createRecord('2f8fd1c1', component.options)
    } else {
      api.reload('2f8fd1c1', component.options)
    }
    module.hot.accept("./relation_fine_group.vue?vue&type=template&id=2f8fd1c1&scoped=true&", function () {
      api.rerender('2f8fd1c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/activity/marketing_promote/components/relation_fine_group.vue"
export default component.exports